import { useQuery } from "@apollo/client";
import React from "react";
import { useRouteMatch } from "react-router";
import { Graphql } from "../../../../graphql/_graphql";
import { useTranslation } from "react-i18next";
import { PageLayout } from "src/components/shopify/PageLayout";
import { Box, Icon, IndexTable, Layout, Text, Thumbnail } from "@shopify/polaris";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import { PolarisEmptyState } from "src/components/shopify/PolarisEmptyState";
import { ArrowRightMinor } from "@shopify/polaris-icons";
import moment from "moment";

export function DiscountDetailScreen() {
  const { t } = useTranslation();
  const { params }: any = useRouteMatch();
  const { data, loading } = useQuery(Graphql.Query.QUERY_DISCOUNT_ITEM, {
    fetchPolicy: "no-cache",
    variables: {
      campaign_id: Number(params.id),
    },
  });

  return (
    <PageLayout
      pageProp={{
        title: "Discount Campaign #" + params.id,
        subtitle: (
          <span style={{ display: "flex", alignItems: "center" }}>
            Schedule:{" "}
            {data && (
              <span className="ml-2" style={{ display: "flex", alignItems: "center" }}>
                {moment(data.merchantDiscountItem.campaign.start_date).format("YYYY:MM:DD")}{" "}
                <Icon source={ArrowRightMinor as any} />
                {moment(data.merchantDiscountItem.campaign.end_date).format("YYYY:MM:DD")}
                <span className="ml-2">
                  (
                  {moment(data.merchantDiscountItem.campaign.end_date).diff(
                    moment(data.merchantDiscountItem.campaign.start_date),
                    "days",
                  )}
                  days)
                </span>
              </span>
            )}
          </span>
        ) as any,
      }}
    >
      <Layout>
        <Layout.Section>
          <PolarisCard roundedAbove="sm" padding={"0"}>
            <Box>
              <IndexTable
                headings={[
                  { title: t("product") },
                  { title: t("original_discount"), alignment: "end" },
                  { title: "" },
                  { title: t("discount"), alignment: "end" },
                ]}
                itemCount={data ? data.merchantDiscountItem.items.length : 0}
                loading={loading}
                emptyState={<PolarisEmptyState />}
                selectable={false}
              >
                {data &&
                  data.merchantDiscountItem.items.map((x: any, i: number) => {
                    const title = Object.values(x.item.title).filter((f) => !!f && f !== "MultiLangString")[0];
                    return (
                      <IndexTable.Row key={i} id={i + ""} position={i}>
                        <IndexTable.Cell>
                          <div style={{ display: "flex" }}>
                            <Thumbnail source={x.item.picture} alt="" size="small" />
                            <div className="ml-3">
                              <Text as="p" variant="bodySm" truncate>
                                {title}
                              </Text>
                              <sub>L192: {x.item.code}</sub>
                            </div>
                          </div>
                        </IndexTable.Cell>
                        <IndexTable.Cell className="text-right">
                          <b>{x.original_discount}%</b>
                        </IndexTable.Cell>
                        <IndexTable.Cell className="text-center">
                          <Icon source={ArrowRightMinor as any} />
                        </IndexTable.Cell>
                        <IndexTable.Cell className="text-right">
                          <b className="text-success">{x.discount}%</b>
                        </IndexTable.Cell>
                      </IndexTable.Row>
                    );
                  })}
              </IndexTable>
            </Box>
          </PolarisCard>
        </Layout.Section>
      </Layout>
    </PageLayout>
  );
}
